const StockLocatorSlider = {

    init(){
        this.el = $('[template="stock_locator"] [block="slider"] .slider');
        if(!this.el.length) return;
        this.bind();
    },

    bind(){
        this.el.addClass('owl-carousel');
        this.el.owlCarousel({
            "smartSpeed": 750,
            "loop": true,
            "autoWidth": false,
            "nav": true,
            "dots": true,
            "progress": true,
            "counter": false,
            "margin": 20,
            "stagePadding": 0,
            "items": 1,
            "navText": ["", ""]
        });
    },
}

export default StockLocatorSlider;